// frontend/src/views/LoginForm.jsx

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../services/authService";
import { setJWTSession } from "../utils/useJWTSession";
import { useTranslation } from "../i18n";
import BaseLayout from "../layouts/BaseLayout";

const LoginForm = () => {
  const navigate = useNavigate();
  const { _ } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const { accessToken } = await loginUser(email, password);
      setJWTSession(accessToken);
      navigate("/authenticated");
    } catch (err) {
      setError(_("Invalid credentials or account type"));
    }
  };

  return (
    <div className="entrypoint-container">
      <h2 className="entrypoint-title font-bold mb-4">
        {_('Login')}
      </h2>
      
      <form
        onSubmit={handleSubmit}
        className="flex flex-col items-center gap-4 px-4 py-6"
      >
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={_("Email")}
          required
          className="input-access"
        />

        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={_("Password")}
          required
          className="input-access"
        />

        {error && <p className="error-text">{error}</p>}

        <button type="submit" className="button-primary mt-2 w-full">
          {_("Log in")}
        </button>

        <div className="mt-4 text-center text-sm text-gray-500 dark:text-gray-300">
          {_('Have an access code instead?')}{' '}
          <a
            href="/"
            className="ml-1 text-blue-500 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-500 rounded"
          >
            {_('Enter it here')}
          </a>
        </div>

      </form>
    </div>
  );
};

export default LoginForm;
